export default "/images/bg-lang.svg?6e0e692fa2512efbf3f99e8efd7f870c";